var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-add-card",on:{"click":function($event){return _vm.$_onClick()}}},[(_vm.icon)?_c('i',{staticClass:"empty-add-card_icon",class:_vm.icon}):_vm._e(),(_vm.title)?_c('p',{staticClass:"empty-add-card_title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }